module.exports = __webpack_public_path__ + "static/img/error-401.98bba5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error-page/error-401.svg
// module id = M3xk
// module chunks = 249